<template>
  <table>
    <thead>
      <tr>
        <th v-for="(item, i) in header" :key="i">
          {{ item }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, rowIndex) in data" :key="rowIndex">
        <td v-for="(field, colIndex) in row" :key="colIndex">
          <slot name="cell" :field="field" :row="row" :rowIndex="rowIndex" :colIndex="colIndex">
            {{ field }}
          </slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import {defineProps} from "vue"
    defineProps({
    header: {
        type: Array,
        default: () => []
    },
    data: {
        type: Array,
        default: () => []
    }
    })
</script>